<template >
  <div id="wrapper" class="gray-bg login-bg">
    <div class="container">

      <div class="row">
        <div class="col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">

          <div class="login">

            <div class="logo">
              <h1>Register</h1>
            </div>

            <form role="form">

              <div class="form-group" :class="{ 'has-error': errors.has('user_type') }">
                <p class="control-label">Register As</p>

                <div class="row">
                  <div class="col-sm-4">
                    <div class="radio" :class="{ 'radio-danger': errors.has('user_type') }">
                      <input v-model="newUser.role_id" v-validate="'required'" type="radio" name="user_type"
                        data-vv-as="user type" id="user-type-client" :value="clientRoleId">
                      <label for="user-type-client">
                        Client
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-8">
                    <div class="radio" :class="{ 'radio-danger': errors.has('user_type') }">
                      <input v-model="newUser.role_id" type="radio" name="user_type" id="user-type-carrier" :value="carrierRoleId">
                      <label for="user-type-carrier">
                        Carrier
                      </label>
                    </div>
                  </div>
                </div><!-- /.row -->
              </div>

              <div class="margin-20"></div>

              <div class="form-group-outer">
                <div class="form-group float-label-control form-group-email" :class="{ 'has-error': errors.has('email') }" >
                  <label for="">Email</label>
                  <input v-model="newUser.email" v-validate="'required|email'" type="email" name="email" class="form-control" placeholder="Email" v-float-label/>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control form-group-email" :class="{ 'has-error': errors.has('password') }">
                  <label for="">Password</label>
                  <input v-model="newUser.password" v-validate="'required'" type="password" name="password" class="form-control" placeholder="Password" v-float-label/>
                </div>
              </div>

              <div class="form-group-outer">
                <div class="form-group float-label-control form-group-email" :class="{ 'has-error': errors.has('password_confirmation') }">
                  <label for="">Repeat Password</label>
                  <input v-model="newUser.password_confirmation" v-validate="'required|confirmed:password'" name="password_confirmation"
                    data-vv-as="password confirmation"
                    type="password" class="form-control" placeholder="Repeat Password" v-float-label/>
                </div>
              </div>

              <div v-if="isCarrier" class="form-group-outer">
                <div class="form-group" :class="{ 'has-error': errors.has('terms_agreed') }">
                  <div class="checkbox checkbox-primary" :class="{ 'checkbox-danger': errors.has('terms_agreed') }">
                    <input v-model="newUser.terms_agreed" v-validate="'required'" name="terms_agreed"
                      data-vv-as="terms agreed" id="terms_agreed" class="styled" type="checkbox">
                    <!-- TODO: Update this href to the correct url of the terms & conditions when we get it (should still be somewhere on their site) -->
                    <label for="terms_agreed">
                      As a Carrier I agree to the <a href="static/TERMS AND CONDITIONS FOR INDEPENDENT CARRIERS.pdf" target="_blank">terms and conditions</a>.
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group-outer" v-if="errors.errors && errors.errors.length">
                <div class="form-group">
                  <div v-for="error of errors.errors" class="alert alert-danger text-right" :key="error.msg" role="alert">
                    {{error.msg}}
                  </div>
                </div>
              </div>

              <div class="text-right">
                <ladda-button size="large" :on-click="registerUser">Register</ladda-button>
              </div>
            </form>

            <div class="login-footer">
              <div class="row">
                <div class="col-xs-7">
                  <router-link :to="{ name: 'auth.login' }"><i class="fa fa-angle-left"></i> Back to Login</router-link>
                </div>
              </div><!-- /.row -->
            </div>

          </div><!-- /.login -->

        </div>
      </div><!-- /.login -->

    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import LaddaButton from 'components/forms/LaddaButton'
  import auth from 'utils/auth'
  import { Roles } from 'utils/user'
  import { mapActions } from 'vuex'
  import { notify, alert } from 'utils'
  import { forIn, each } from 'lodash'

  export default {
    data () {
      return {
        newUser: {
          role_id: null,
          email: null,
          password: null,
          password_confirmation: null
        }
      }
    },

    computed: {
      clientRoleId () {
        return Roles.CLIENT
      },

      carrierRoleId () {
        return Roles.CARRIER
      },

      isCarrier () {
        return this.newUser.role_id === this.carrierRoleId
      }
    },

    components: {
      LaddaButton
    },

    mounted () {
      $('body').addClass('pace-top')
    },

    methods: {
      ...mapActions('user', ['register']),

      handleRegister () {
        const attemptAuthentication = () => {
          return auth.attempt(this.newUser.email, this.newUser.password)
        }

        const getBrowserDetails = () => {
          return {
            userAgent: navigator.userAgent,
            appName: navigator.appName,
            appVersion: navigator.appVersion,
            platform: navigator.platform,
            vendor: navigator.vendor
          }
        }

        this.newUser.browser_info = JSON.stringify(getBrowserDetails())

        // Proceed with registration and authentication
        return this.register(this.newUser)
          .then(attemptAuthentication)
          .then(() => {
            this.$router.push({ name: 'auth.details' })
          })
          .catch(({ response }) => {
            // If server validation has failed then we'll spin through all the error keys and errors
            // for those keys to add the errors to our form.
            if (response.status === 422) {
              this.errors.clear()

              forIn(response.data.errors, (errors, key) => {
                each(errors, error => {
                  this.errors.add(key, error)
                  notify.error(error)
                })
              })
            }
          })
      },

      registerUser () {
        return this.validateAll().then(() => {
          return alert.confirm({
            html: `
              If you are an employee of a company which is already <br />
              registered with us, please add your profile using <br />
              the Accounts tab within the platform or contact <br />
              Ian Forster on <b>0458 951 969</b> for assistance.
            `,
            title: 'Registration',
            confirmButtonText: 'Continue',
            showLoaderOnConfirm: true,
            preConfirm: confirmed => {
              if (confirmed) {
                return this.handleRegister()
              }

              return Promise.reject()
            }
          })
        })
      }
    }
  }
</script>

<style>
  .float-label-control label {
    z-index: 1;
  }
</style>



// WEBPACK FOOTER //
// Register.vue?43edec1c